<aside id="sidebar" class="w-[200px] mx-12px mt-[12px]" aria-label="Sidebar">
	<div class="overflow-x-hidden bg-main-color-black text-off-white rounded-3xl">
		<div class="text-center pt-36px">
			<img
				class="mx-auto w-[120px] h-[44px]"
				src="assets/images/App Icon - Logo.svg"
				alt="logo"
			/>
		</div>
		<hr class="text-off-white w-[134px] opacity-10 mt-[24px] mx-auto" />
		<div class="sidebar-items flex flex-col justify-between">
			<ul class="mt-[33px] h-[70vh] overflow-y-auto">
				<!--
#TODO: Return this when we make home for dashboard
-->
				<!-- <li class="text-center px-[24px] mb-[20px]">
          <a
            routerLinkActive="text-gradient"
            class="flex gap-2 items-center text-off-white text-center cursor-default"
          >
            <div class="w-5 mb-0.5">
              <svg viewBox="0 0 21.5 21.5" class="disabled">
                <path
                  class="cls-1"
                  d="M18.52,12.5h-4c-2,0-3-.93-3-2.85V2.85c0-1.92,1-2.85,3-2.85h4c2,0,3,.93,3,2.85v6.8C21.5,11.57,20.52,12.5,18.52,12.5Zm-4-11C13.21,1.5,13,1.84,13,2.85v6.8c0,1,.21,1.35,1.48,1.35h4C19.79,11,20,10.66,20,9.65V2.85c0-1-.21-1.35-1.48-1.35Zm4,20h-4c-2,0-3-.93-3-2.85v-1.8c0-1.92,1-2.85,3-2.85h4c2,0,3,.93,3,2.85v1.8C21.5,20.57,20.52,21.5,18.52,21.5Zm-4-6c-1.27,0-1.48.34-1.48,1.35v1.8c0,1,.21,1.35,1.48,1.35h4c1.27,0,1.48-.34,1.48-1.35v-1.8c0-1-.21-1.35-1.48-1.35ZM7,21.5H3c-2,0-3-.93-3-2.85v-6.8C0,9.93,1,9,3,9H7c2,0,3,.93,3,2.85v6.8C10,20.57,9,21.5,7,21.5Zm-4-11c-1.27,0-1.48.34-1.48,1.35v6.8C1.5,19.66,1.71,20,3,20H7c1.27,0,1.48-.34,1.48-1.35v-6.8c0-1-.21-1.35-1.48-1.35Zm4-3H3c-2,0-3-.93-3-2.85V2.85C0,.93,1,0,3,0H7c2,0,3,.93,3,2.85v1.8C10,6.57,9,7.5,7,7.5Zm-4-6c-1.27,0-1.48.34-1.48,1.35v1.8C1.5,5.66,1.71,6,3,6H7C8.29,6,8.5,5.66,8.5,4.65V2.85c0-1-.21-1.35-1.48-1.35Z"
                />
              </svg>
            </div>
            <span class="text-center text-disabled-btn-txt-Color">
              {{ 'SIDEBAR.DASHBOARD' | translate }}</span
            >
          </a>
        </li> -->

				<li class="text-center px-[24px] mb-[20px]">
					<a
						(click)="closeFun(); closeSubMenu('')"
						routerLink="./service-providers"
						routerLinkActive="text-gradient"
						class="flex gap-2 items-center text-off-white cursor-pointer navbar-item"
					>
						<div class="w-5 mb-0.5">
							<svg viewBox="0 0 21.33 20">
								<path
									d="M5.2,10.53H16.13v2.06H17.2V9.47h-6V7.33H10.13V9.47h-6v3.12H5.2ZM8,13.33H1.33A1.33,1.33,0,0,0,0,14.67v4A1.33,1.33,0,0,0,1.33,20H8a1.33,1.33,0,0,0,1.33-1.33v-4A1.33,1.33,0,0,0,8,13.33ZM1.33,18.67v-4H8v4ZM20,13.33H13.33A1.33,1.33,0,0,0,12,14.67v4A1.33,1.33,0,0,0,13.33,20H20a1.33,1.33,0,0,0,1.33-1.33v-4A1.33,1.33,0,0,0,20,13.33Zm-6.67,5.34v-4H20v4Zm-6-12H14a1.33,1.33,0,0,0,1.33-1.34v-4A1.33,1.33,0,0,0,14,0H7.33A1.33,1.33,0,0,0,6,1.33v4A1.33,1.33,0,0,0,7.33,6.67Zm0-5.34H14v4H7.33Z"
								/>
							</svg>
						</div>

						<span class="text-center whitespace-nowrap">{{
							'SIDEBAR.SERVICEPROVIDERS' | translate
						}}</span>
					</a>
				</li>
				<li class="text-center px-[24px] mb-[20px]">
					<a
						(click)="closeFun(); closeSubMenu('')"
						routerLink="./booking"
						routerLinkActive="text-gradient"
						class="flex gap-2 items-center text-off-white cursor-pointer navbar-item"
					>
						<div class="w-5 mb-0.5">
							<svg viewBox="0 0 19.5 21.5">
								<path
									d="M5.75,4.5A.76.76,0,0,1,5,3.75v-3a.75.75,0,0,1,1.5,0v3A.76.76,0,0,1,5.75,4.5Zm8,0A.76.76,0,0,1,13,3.75v-3a.75.75,0,0,1,1.5,0v3A.76.76,0,0,1,13.75,4.5Zm-7.5,8.75a1,1,0,0,1-.38-.08,1,1,0,0,1-.62-.92,1,1,0,0,1,.08-.38,1.15,1.15,0,0,1,.21-.33,1,1,0,0,1,.33-.21A1,1,0,0,1,7,11.54a1.05,1.05,0,0,1,.29.71,1.5,1.5,0,0,1,0,.2.64.64,0,0,1-.06.18.76.76,0,0,1-.09.18A1.58,1.58,0,0,1,7,13,1.05,1.05,0,0,1,6.25,13.25Zm3.5,0a1,1,0,0,1-.38-.08,1,1,0,0,1-.62-.92,1,1,0,0,1,.08-.38A1.15,1.15,0,0,1,9,11.54a1,1,0,0,1,.33-.21,1,1,0,0,1,1.09.21,1.05,1.05,0,0,1,.29.71,1.5,1.5,0,0,1,0,.2.64.64,0,0,1-.06.18.76.76,0,0,1-.09.18,1.58,1.58,0,0,1-.12.15A1.05,1.05,0,0,1,9.75,13.25Zm3.5,0a1,1,0,0,1-.38-.08,1,1,0,0,1-.33-.21l-.12-.15a.76.76,0,0,1-.09-.18.64.64,0,0,1-.06-.18,1.5,1.5,0,0,1,0-.2,1.05,1.05,0,0,1,.29-.71,1,1,0,0,1,.33-.21,1,1,0,0,1,1.09.21,1.05,1.05,0,0,1,.29.71,1.5,1.5,0,0,1,0,.2.64.64,0,0,1-.06.18.76.76,0,0,1-.09.18A1.58,1.58,0,0,1,14,13,1.05,1.05,0,0,1,13.25,13.25Zm-7,3.5a1,1,0,0,1-.38-.08,1.15,1.15,0,0,1-.33-.21,1.05,1.05,0,0,1-.29-.71,1,1,0,0,1,.08-.38A.93.93,0,0,1,5.54,15a1,1,0,1,1,.71,1.71Zm3.5,0a1,1,0,0,1-1-1,1,1,0,0,1,.08-.38A.93.93,0,0,1,9,15a1,1,0,0,1,1.42,0,.93.93,0,0,1,.21.33,1,1,0,0,1,.08.38,1,1,0,0,1-1,1Zm3.5,0a1.05,1.05,0,0,1-.71-.29.93.93,0,0,1-.21-.33.94.94,0,0,1,0-.76.93.93,0,0,1,.21-.33,1,1,0,0,1,.9-.27.6.6,0,0,1,.19.06l.18.09L14,15a1,1,0,0,1-.71,1.71Zm5-8.16h-17a.75.75,0,0,1,0-1.5h17a.75.75,0,0,1,0,1.5ZM13.75,21.5h-8C2.1,21.5,0,19.4,0,15.75V7.25C0,3.6,2.1,1.5,5.75,1.5h8c3.65,0,5.75,2.1,5.75,5.75v8.5C19.5,19.4,17.4,21.5,13.75,21.5ZM5.75,3C2.89,3,1.5,4.39,1.5,7.25v8.5C1.5,18.61,2.89,20,5.75,20h8C16.61,20,18,18.61,18,15.75V7.25C18,4.39,16.61,3,13.75,3Z"
								/>
							</svg>
						</div>
						<span class="text-center">{{
							'SIDEBAR.BOOKINGS' | translate
						}}</span>
					</a>
				</li>

				<li class="text-center px-[24px] mb-[20px]">
					<a
						(click)="closeFun(); closeSubMenu('openOffer')"
						[ngClass]="tabs.openOffer ? 'text-gradient' : ''"
						class="flex gap-2 items-center text-off-white cursor-pointer navbar-item"
					>
						<div class="w-5 mb-0.5">
							<svg width="24" height="25" viewBox="0 0 24 25">
								<path
									d="M10.6975 21.9306L10.6975 21.9305L10.6936 21.9266L9.17356 20.4065C9.0437 20.2767 8.86118 20.1838 8.72588 20.128C8.59146 20.0724 8.39876 20.0101 8.22 20.0101H6.06C5.03617 20.0101 4.20999 19.1839 4.20999 18.16V16.0001C4.20999 15.8213 4.14764 15.6286 4.09212 15.4942C4.03623 15.3589 3.9434 15.1764 3.81354 15.0466L2.29356 13.5265L1.94 13.8801L2.29356 13.5265C1.94577 13.1788 1.75 12.7153 1.75 12.2201C1.75 11.72 1.93904 11.2603 2.28956 10.9175L2.28958 10.9176L2.29356 10.9136L3.81354 9.39356C3.81355 9.39356 3.81355 9.39356 3.81355 9.39355C3.9434 9.2637 4.03623 9.0812 4.09212 8.94591C4.14764 8.81149 4.20999 8.61879 4.20999 8.44003V6.28012C4.20999 5.25623 5.03617 4.43002 6.06 4.43002H8.22C8.39876 4.43002 8.59146 4.36767 8.72588 4.31215C8.86118 4.25627 9.0437 4.16344 9.17356 4.03357L9.17356 4.03357L10.6936 2.51355C11.3783 1.82882 12.6217 1.82882 13.3064 2.51355L14.8264 4.03357L15.1767 3.68326L14.8264 4.03357C14.9563 4.16344 15.1388 4.25627 15.2741 4.31215C15.4085 4.36767 15.6012 4.43002 15.78 4.43002H17.94C18.9638 4.43002 19.79 5.25623 19.79 6.28012V8.44003C19.79 8.61879 19.8524 8.81149 19.9079 8.94591C19.9638 9.0812 20.0566 9.2637 20.1865 9.39356L21.7064 10.9136L22.06 10.56L21.7064 10.9136C22.0542 11.2614 22.25 11.7248 22.25 12.2201C22.25 12.7202 22.061 13.1799 21.7104 13.5226L21.7104 13.5226L21.7064 13.5265L20.1865 15.0466C20.0566 15.1764 19.9638 15.3589 19.9079 15.4942C19.8524 15.6286 19.79 15.8213 19.79 16.0001V18.16C19.79 19.1839 18.9638 20.0101 17.94 20.0101H15.78C15.6012 20.0101 15.4085 20.0724 15.2741 20.128C15.1388 20.1838 14.9563 20.2767 14.8264 20.4065L13.3064 21.9266L13.3064 21.9265L13.3025 21.9306C12.9598 22.2811 12.5001 22.4701 12 22.4701C11.4999 22.4701 11.0402 22.2811 10.6975 21.9306ZM4.16643 14.6936L4.51999 14.3401L4.16644 14.6936C4.47312 15.0003 4.70999 15.5733 4.70999 16.0001V18.16C4.70999 18.9061 5.31379 19.5101 6.06 19.5101H8.22C8.64678 19.5101 9.21979 19.7469 9.52645 20.0536L11.0464 21.5736L11.4 21.2201L11.0464 21.5736C11.5617 22.0889 12.4383 22.0889 12.9536 21.5736L12.6 21.2201L12.9536 21.5736L14.4736 20.0536C14.7802 19.7469 15.3532 19.5101 15.78 19.5101H17.94C18.6862 19.5101 19.29 18.9061 19.29 18.16V16.0001C19.29 15.5733 19.5269 15.0003 19.8336 14.6936L19.48 14.3401L19.8336 14.6936L21.3536 13.1736C21.6049 12.9223 21.75 12.5861 21.75 12.2201C21.75 11.854 21.6049 11.5179 21.3536 11.2665L19.8336 9.74651L19.48 10.1001L19.8336 9.74651C19.5269 9.43983 19.29 8.86679 19.29 8.44003V6.28012C19.29 5.53404 18.6862 4.93002 17.94 4.93002H15.78C15.3532 4.93002 14.7802 4.69319 14.4735 4.38652L12.9536 2.86651L12.6 3.22006L12.9536 2.86651C12.4383 2.35124 11.5617 2.35124 11.0464 2.86651L11.4 3.22006L11.0464 2.86651L9.52645 4.38653C9.21979 4.69319 8.64678 4.93002 8.22 4.93002H6.06C5.31379 4.93002 4.70999 5.53404 4.70999 6.28012V8.44003C4.70999 8.86679 4.47312 9.43983 4.16644 9.74651L4.51999 10.1001L4.16643 9.74651L2.64644 11.2665C2.39511 11.5179 2.25 11.854 2.25 12.2201C2.25 12.5861 2.39511 12.9223 2.64645 13.1736L4.16643 14.6936Z"
								/>
								<path
									d="M15.0022 16.2188C14.4422 16.2188 13.9922 15.7687 13.9922 15.2188C13.9922 14.6687 14.4422 14.2188 14.9922 14.2188C15.5422 14.2188 15.9922 14.6687 15.9922 15.2188C15.9922 15.7687 15.5522 16.2188 15.0022 16.2188Z"
								/>
								<path
									d="M9.01001 10.2188C8.45001 10.2188 8 9.76875 8 9.21875C8 8.66875 8.45 8.21875 9 8.21875C9.55 8.21875 10 8.66875 10 9.21875C10 9.76875 9.56001 10.2188 9.01001 10.2188Z"
								/>
								<path
									d="M9.00141 15.9702C8.81141 15.9702 8.62141 15.9002 8.47141 15.7502C8.18141 15.4602 8.18141 14.9802 8.47141 14.6902L14.4714 8.69016C14.7614 8.40016 15.2414 8.40016 15.5314 8.69016C15.8214 8.98016 15.8214 9.46021 15.5314 9.75021L9.5314 15.7502C9.3814 15.9002 9.1914 15.9702 9.00141 15.9702Z"
								/>
							</svg>
						</div>
						<span class="text-center mx-1">{{
							'SIDEBAR.OFFERS' | translate
						}}</span>
					</a>
					<div *ngIf="tabs.openOffer" class="mx-7">
						<a
							(click)="closeFun(); closeSubMenu('openOffer')"
							routerLink="./offer"
							routerLinkActive="text-gradient"
							class="flex gap-2 items-center text-off-white cursor-pointer navbar-item mt-2"
						>
							<span class="text-center">{{ 'SIDEBAR.SALON' | translate }}</span>
						</a>
						<a
							(click)="closeFun(); closeSubMenu('openOffer')"
							routerLink="./store/products/product-promocode-list"
							routerLinkActive="text-gradient"
							class="flex gap-2 items-center text-off-white cursor-pointer navbar-item mt-2"
						>
							<span class="text-center">{{ 'SIDEBAR.STORE' | translate }}</span>
						</a>
					</div>
				</li>
				<!--
#TODO: Return this when we start again in roles and permissions
-->
				<li class="text-center px-[15px] mb-[20px]">
					<a
						(click)="closeFun(); closeSubMenu('')"
						routerLink="./roles-permissions"
						routerLinkActive="text-gradient"
						class="flex gap-2 items-center text-off-white cursor-pointer navbar-item"
					>
						<div class="w-5 mb-0.5">
							<svg width="24" height="24" viewBox="0 0 24 25">
								<path
									d="M7 8.46875H4C2.75614 8.46875 1.75 7.46261 1.75 6.21875V4.21875C1.75 2.97489 2.75614 1.96875 4 1.96875H7C8.24386 1.96875 9.25 2.97489 9.25 4.21875V6.21875C9.25 7.46261 8.24386 8.46875 7 8.46875ZM4 2.46875C3.03386 2.46875 2.25 3.25261 2.25 4.21875V6.21875C2.25 7.18489 3.03386 7.96875 4 7.96875H7C7.96614 7.96875 8.75 7.18489 8.75 6.21875V4.21875C8.75 3.25261 7.96614 2.46875 7 2.46875H4Z"
								/>
								<path
									d="M20.8 7.96875H17.2C16.12 7.96875 15.25 7.08874 15.25 6.01874V4.41876C15.25 3.33876 16.13 2.46875 17.2 2.46875H20.8C21.88 2.46875 22.75 3.34876 22.75 4.41876V6.01874C22.75 7.09874 21.88 7.96875 20.8 7.96875ZM17.2 3.96875C16.96 3.96875 16.75 4.17876 16.75 4.41876V6.01874C16.75 6.25874 16.96 6.46875 17.2 6.46875H20.8C21.04 6.46875 21.25 6.25874 21.25 6.01874V4.41876C21.25 4.17876 21.04 3.96875 20.8 3.96875H17.2Z"
								/>
								<path
									d="M20.8 15.4688H17.2C16.12 15.4688 15.25 14.5887 15.25 13.5187V11.9188C15.25 10.8388 16.13 9.96875 17.2 9.96875H20.8C21.88 9.96875 22.75 10.8488 22.75 11.9188V13.5187C22.75 14.5987 21.88 15.4688 20.8 15.4688ZM17.2 11.4688C16.96 11.4688 16.75 11.6788 16.75 11.9188V13.5187C16.75 13.7587 16.96 13.9688 17.2 13.9688H20.8C21.04 13.9688 21.25 13.7587 21.25 13.5187V11.9188C21.25 11.6788 21.04 11.4688 20.8 11.4688H17.2Z"
								/>
								<path
									d="M16 5.96875H9C8.59 5.96875 8.25 5.62875 8.25 5.21875C8.25 4.80875 8.59 4.46875 9 4.46875H16C16.41 4.46875 16.75 4.80875 16.75 5.21875C16.75 5.62875 16.41 5.96875 16 5.96875Z"
								/>
								<path
									d="M16 20.9688H14.5C12.98 20.9688 11.75 19.7388 11.75 18.2188V5.21875C11.75 4.80875 12.09 4.46875 12.5 4.46875C12.91 4.46875 13.25 4.80875 13.25 5.21875V18.2188C13.25 18.9087 13.81 19.4688 14.5 19.4688H16C16.41 19.4688 16.75 19.8088 16.75 20.2188C16.75 20.6287 16.41 20.9688 16 20.9688Z"
								/>
								<path
									d="M16 13.4688H12.5C12.09 13.4688 11.75 13.1287 11.75 12.7188C11.75 12.3088 12.09 11.9688 12.5 11.9688H16C16.41 11.9688 16.75 12.3088 16.75 12.7188C16.75 13.1287 16.41 13.4688 16 13.4688Z"
								/>
								<path
									d="M20.8 22.9688H17.2C16.12 22.9688 15.25 22.0887 15.25 21.0187V19.4188C15.25 18.3388 16.13 17.4688 17.2 17.4688H20.8C21.88 17.4688 22.75 18.3488 22.75 19.4188V21.0187C22.75 22.0987 21.88 22.9688 20.8 22.9688ZM17.2 18.9688C16.96 18.9688 16.75 19.1788 16.75 19.4188V21.0187C16.75 21.2587 16.96 21.4688 17.2 21.4688H20.8C21.04 21.4688 21.25 21.2587 21.25 21.0187V19.4188C21.25 19.1788 21.04 18.9688 20.8 18.9688H17.2Z"
								/>
							</svg>
						</div>
						<span class="text-center whitespace-nowrap text-[13.5px] mx-1">{{
							'SIDEBAR.ROLES' | translate
						}}</span>
					</a>
				</li>

				<li class="text-center px-[24px] mb-[20px]">
					<a
						(click)="closeFun(); closeSubMenu('')"
						routerLink="./clients"
						routerLinkActive="text-gradient"
						class="flex gap-2 items-center text-off-white cursor-pointer navbar-item"
					>
						<div class="w-5 mb-0.5">
							<svg viewBox="0 0 20.63 21.3">
								<path
									d="M7.56,10.37H7.3a5.15,5.15,0,1,1,.29,0ZM7.4,1.5a3.69,3.69,0,0,0-.14,7.37h.32A3.69,3.69,0,0,0,7.4,1.5Zm7.54,9h-.09A.79.79,0,0,1,14,9.83.73.73,0,0,1,14.6,9H15a2.75,2.75,0,0,0-.15-5.5.74.74,0,0,1-.75-.74A.76.76,0,0,1,14.81,2,4.25,4.25,0,0,1,15,10.5ZM7.57,21.3a9.88,9.88,0,0,1-5.42-1.5A4.29,4.29,0,0,1,0,16.25a4.34,4.34,0,0,1,2.15-3.57,10.59,10.59,0,0,1,10.84,0,4.31,4.31,0,0,1,2.15,3.55A4.34,4.34,0,0,1,13,19.8,9.9,9.9,0,0,1,7.57,21.3ZM3,13.94A2.88,2.88,0,0,0,1.5,16.26,2.87,2.87,0,0,0,3,18.56a9,9,0,0,0,9.18,0,2.88,2.88,0,0,0,1.48-2.32,2.87,2.87,0,0,0-1.48-2.3A9.08,9.08,0,0,0,3,13.94ZM16.74,19.5a.74.74,0,0,1-.73-.6.76.76,0,0,1,.58-.89,4.05,4.05,0,0,0,1.66-.73,2,2,0,0,0,.88-1.54,1.94,1.94,0,0,0-.87-1.53,4.19,4.19,0,0,0-1.64-.73A.75.75,0,0,1,17,12a5.58,5.58,0,0,1,2.22,1,3.44,3.44,0,0,1,1.46,2.73,3.48,3.48,0,0,1-1.47,2.74,5.42,5.42,0,0,1-2.26,1A.47.47,0,0,1,16.74,19.5Z"
								/>
							</svg>
						</div>
						<span class="text-center">{{ 'SIDEBAR.CLIENTS' | translate }}</span>
					</a>
				</li>
				<!-- #TODO: Return this when we make USERS  -->

				 <li class="text-center px-[24px] mb-[20px]"> 
					<a
						(click)="closeFun()"
						routerLink="./users"
						routerLinkActive="text-gradient"
						class="flex gap-2 items-center text-off-white cursor-pointer navbar-item"
					>
						<div class="w-5 mb-0.5">
							<svg viewBox="0 0 15.14 21.32">
								<path
									d="M7.25,9.2h.34a4,4,0,0,0,3.81-4h0a4,4,0,1,0-4.15,4Zm.32,1.21H7.26A5.08,5.08,0,0,1,2.4,5.21,5.11,5.11,0,0,1,7.4,0a5.12,5.12,0,0,1,5,5.21,5.1,5.1,0,0,1-4.81,5.2h0Zm0,10.91a9.88,9.88,0,0,1-5.42-1.5A4.29,4.29,0,0,1,0,16.27,4.34,4.34,0,0,1,2.15,12.7,10.59,10.59,0,0,1,13,12.7a4.31,4.31,0,0,1,2.15,3.55A4.34,4.34,0,0,1,13,19.82,9.9,9.9,0,0,1,7.57,21.32ZM3,14A2.88,2.88,0,0,0,1.5,16.28,2.87,2.87,0,0,0,3,18.58a9,9,0,0,0,9.18,0,2.88,2.88,0,0,0,1.48-2.32A2.87,2.87,0,0,0,12.16,14,9.08,9.08,0,0,0,3,14Z"
								/>
							</svg>
						</div>
						<span class="text-center">{{ 'SIDEBAR.USERS' | translate }}</span>
					</a>
				</li>
				<li class="text-center px-[24px] mb-[20px]">
					<a
						(click)="closeFun(); closeSubMenu('')"
						routerLink="./refunds"
						routerLinkActive="text-gradient"
						class="flex gap-2 items-center text-off-white cursor-pointer navbar-item"
					>
						<div class="w-5 mb-0.5">
							<svg viewBox="0 0 21.51 21.5">
								<path
									d="M20.75,5.06h-10a.75.75,0,1,1,0-1.5h10a.75.75,0,1,1,0,1.5ZM18.53,10H13c-2.19,0-3-.77-3-2.95V3C10,.77,10.79,0,13,0h5.55c2.19,0,3,.77,3,3V7.06C21.5,9.23,20.72,10,18.53,10ZM13,1.5c-1.36,0-1.47.11-1.47,1.45V7.06c0,1.34.11,1.45,1.47,1.45h5.55C19.88,8.51,20,8.4,20,7.06V3c0-1.34-.11-1.45-1.47-1.45ZM10.75,16.56H.75a.75.75,0,1,1,0-1.5h10a.75.75,0,0,1,0,1.5ZM8.53,21.5H3c-2.19,0-3-.77-3-2.95v-4.1c0-2.18.78-2.95,3-2.95H8.53c2.19,0,3,.77,3,2.95v4.11C11.5,20.73,10.72,21.5,8.53,21.5ZM3,13c-1.36,0-1.47.11-1.47,1.45v4.11C1.5,19.9,1.61,20,3,20H8.52C9.88,20,10,19.9,10,18.56V14.45C10,13.11,9.88,13,8.52,13Zm10.78,8.5a.75.75,0,0,1-.65-.38.76.76,0,0,1,0-.76l1.05-1.75a.76.76,0,0,1,1-.26.75.75,0,0,1,.26,1l-.27.45A6.27,6.27,0,0,0,20,13.74a.75.75,0,1,1,1.5,0A7.78,7.78,0,0,1,13.75,21.5Zm-13-13A.76.76,0,0,1,0,7.75,7.76,7.76,0,0,1,7.75,0,.75.75,0,0,1,8.4.38a.76.76,0,0,1,0,.76L7.34,2.89a.76.76,0,0,1-1,.26.75.75,0,0,1-.26-1l.27-.45A6.27,6.27,0,0,0,1.49,7.76.74.74,0,0,1,.75,8.5Z"
								/>
							</svg>
						</div>
						<span class="text-center">{{ 'SIDEBAR.REFUND' | translate }}</span>
					</a>
				</li>
				<li class="text-center px-[24px] mb-[20px]">
					<a
						(click)="closeFun(); closeSubMenu('openPayout')"
						[ngClass]="tabs.openPayout ? 'text-gradient' : ''"
						class="flex gap-2 items-center text-off-white cursor-pointer navbar-item"
					>
						<div class="w-5 mb-0.5">
							<svg width="24" height="25" viewBox="0 0 24 25">
								<path
									d="M14.5 9.46875H2C1.59 9.46875 1.25 9.12875 1.25 8.71875C1.25 8.30875 1.59 7.96875 2 7.96875H14.5C14.91 7.96875 15.25 8.30875 15.25 8.71875C15.25 9.12875 14.91 9.46875 14.5 9.46875Z"
								/>
								<path
									d="M8 17.4688H6C5.59 17.4688 5.25 17.1287 5.25 16.7188C5.25 16.3088 5.59 15.9688 6 15.9688H8C8.41 15.9688 8.75 16.3088 8.75 16.7188C8.75 17.1287 8.41 17.4688 8 17.4688Z"
								/>
								<path
									d="M14.5 17.4688H10.5C10.09 17.4688 9.75 17.1287 9.75 16.7188C9.75 16.3088 10.09 15.9688 10.5 15.9688H14.5C14.91 15.9688 15.25 16.3088 15.25 16.7188C15.25 17.1287 14.91 17.4688 14.5 17.4688Z"
								/>
								<path
									d="M17.56 21.4688H6.44C2.46 21.4688 1.25 20.2688 1.25 16.3288V8.10875C1.25 4.16875 2.46 2.96875 6.44 2.96875H14.5C14.91 2.96875 15.25 3.30875 15.25 3.71875C15.25 4.12875 14.91 4.46875 14.5 4.46875H6.44C3.3 4.46875 2.75 5.00875 2.75 8.10875V16.3188C2.75 19.4188 3.3 19.9587 6.44 19.9587H17.55C20.69 19.9587 21.24 19.4188 21.24 16.3188V14.2388C21.24 13.8288 21.58 13.4888 21.99 13.4888C22.4 13.4888 22.74 13.8288 22.74 14.2388V16.3188C22.75 20.2688 21.54 21.4688 17.56 21.4688Z"
								/>
								<path
									d="M20 10.4706C19.59 10.4706 19.25 10.1306 19.25 9.72064V3.72064C19.25 3.42064 19.43 3.14064 19.71 3.03064C19.99 2.92064 20.31 2.98064 20.53 3.19064L22.53 5.19064C22.82 5.48064 22.82 5.96064 22.53 6.25064C22.24 6.54064 21.76 6.54064 21.47 6.25064L20.75 5.53064V9.72064C20.75 10.1306 20.41 10.4706 20 10.4706Z"
								/>
								<path
									d="M18.0014 6.47016C17.8114 6.47016 17.6214 6.40016 17.4714 6.25016C17.1814 5.96016 17.1814 5.48016 17.4714 5.19016L19.4714 3.19016C19.7614 2.90016 20.2414 2.90016 20.5314 3.19016C20.8214 3.48016 20.8214 3.96016 20.5314 4.25016L18.5314 6.25016C18.3814 6.40016 18.1914 6.47016 18.0014 6.47016Z"
								/>
							</svg>
						</div>
						<span class="text-center mx-1">{{
							'SIDEBAR.PAYOUT' | translate
						}}</span>
					</a>
					<div *ngIf="tabs.openPayout" class="mx-3">
						<a
							(click)="closeFun(); closeSubMenu('openPayout')"
							routerLink="./payouts/sp-payout"
							routerLinkActive="text-gradient"
							class="flex gap-2 items-center text-off-white cursor-pointer navbar-item mt-2"
						>
							<span class="text-center whitespace-nowrap">{{
								'SIDEBAR.SERVICEPROVIDERS' | translate
							}}</span>
						</a>
						<a
							(click)="closeFun(); closeSubMenu('openPayout')"
							routerLink="./payouts/clients-payout"
							routerLinkActive="text-gradient"
							class="flex gap-2 items-center text-off-white cursor-pointer navbar-item mt-2"
						>
							<span class="text-center">{{
								'SIDEBAR.CLIENTS' | translate
							}}</span>
						</a>
					</div>
				</li>

				<li class="text-center px-[24px] mb-[20px]">
					<a
						(click)="closeFun(); closeSubMenu('openFinance')"
						[ngClass]="tabs.openFinance ? 'text-gradient' : ''"
						class="flex gap-2 items-center text-off-white cursor-pointer navbar-item"
					>
						<div class="w-5 mb-0.5">
							<svg width="24" height="25" viewBox="0 0 24 25">
								<path
									d="M12 22.9672C8 22.9672 4.75 20.0972 4.75 16.5672V12.8672C4.75 12.4572 5.09 12.1172 5.5 12.1172C5.91 12.1172 6.25 12.4572 6.25 12.8672C6.25 15.4872 8.72 17.4672 12 17.4672C15.28 17.4672 17.75 15.4872 17.75 12.8672C17.75 12.4572 18.09 12.1172 18.5 12.1172C18.91 12.1172 19.25 12.4572 19.25 12.8672V16.5672C19.25 20.0972 16 22.9672 12 22.9672ZM6.25 16.6772C6.32 19.3272 8.87 21.4672 12 21.4672C15.13 21.4672 17.68 19.3272 17.75 16.6772C16.45 18.0872 14.39 18.9672 12 18.9672C9.61 18.9672 7.56 18.0872 6.25 16.6772Z"
								/>
								<path
									d="M12 13.9688C9.24 13.9688 6.75999 12.7287 5.54999 10.7287C5.02999 9.87875 4.75 8.88875 4.75 7.86875C4.75 6.14875 5.52 4.52875 6.91 3.30875C8.27 2.11875 10.08 1.46875 12 1.46875C13.92 1.46875 15.72 2.11875 17.09 3.29875C18.48 4.52875 19.25 6.14875 19.25 7.86875C19.25 8.88875 18.97 9.86875 18.45 10.7287C17.24 12.7287 14.76 13.9688 12 13.9688ZM12 2.96875C10.44 2.96875 8.98001 3.48875 7.89001 4.44875C6.83001 5.36875 6.25 6.58875 6.25 7.86875C6.25 8.61875 6.44999 9.31875 6.82999 9.94875C7.77999 11.5087 9.76 12.4688 12 12.4688C14.24 12.4688 16.22 11.4987 17.17 9.94875C17.56 9.31875 17.75 8.61875 17.75 7.86875C17.75 6.58875 17.17 5.36875 16.1 4.42875C15.01 3.48875 13.56 2.96875 12 2.96875Z"
								/>
								<path
									d="M12 18.9688C7.87 18.9688 4.75 16.3488 4.75 12.8688V7.86875C4.75 4.33875 8 1.46875 12 1.46875C13.92 1.46875 15.72 2.11875 17.09 3.29875C18.48 4.52875 19.25 6.14875 19.25 7.86875V12.8688C19.25 16.3488 16.13 18.9688 12 18.9688ZM12 2.96875C8.83 2.96875 6.25 5.16875 6.25 7.86875V12.8688C6.25 15.4888 8.72 17.4688 12 17.4688C15.28 17.4688 17.75 15.4888 17.75 12.8688V7.86875C17.75 6.58875 17.17 5.36875 16.1 4.42875C15.01 3.48875 13.56 2.96875 12 2.96875Z"
								/>
							</svg>
						</div>
						<span class="text-center">{{
							'SIDEBAR.FINANCIAL' | translate
						}}</span>
					</a>
					<div *ngIf="tabs.openFinance" class="mx-7">
						<a
							(click)="closeFun(); closeSubMenu('openFinance')"
							routerLink="./wallet/financial-list"
							routerLinkActive="text-gradient"
							class="flex gap-2 items-center text-off-white cursor-pointer navbar-item mt-2"
						>
							<span class="text-center">{{
								'SIDEBAR.FINANCIAL' | translate
							}}</span>
						</a>
						<a
							(click)="closeFun(); closeSubMenu('openFinance')"
							routerLink="./wallet/admin-wallet"
							routerLinkActive="text-gradient"
							class="flex gap-2 items-center text-off-white cursor-pointer navbar-item mt-2"
						>
							<span class="text-center">{{
								'SIDEBAR.WALLET' | translate
							}}</span>
						</a>
					</div>
				</li>

				<li class="text-center px-[24px] mb-[20px]">
					<a
						(click)="closeFun(); closeSubMenu('openStore')"
						[ngClass]="tabs.openStore ? 'text-gradient' : ''"
						class="flex gap-2 items-center text-off-white cursor-pointer navbar-item"
					>
						<div class="w-5 mb-0.5">
							<svg width="24" height="25" viewBox="0 0 24 25">
								<path
									d="M14.7017 22.9675H9.30172C4.36172 22.9675 2.26172 20.8575 2.26172 15.9275V11.4375C2.26172 11.0275 2.60172 10.6875 3.01172 10.6875C3.42172 10.6875 3.76172 11.0275 3.76172 11.4375V15.9275C3.76172 20.0175 5.21172 21.4675 9.30172 21.4675H14.6917C18.7817 21.4675 20.2317 20.0175 20.2317 15.9275V11.4375C20.2317 11.0275 20.5717 10.6875 20.9817 10.6875C21.3917 10.6875 21.7317 11.0275 21.7317 11.4375V15.9275C21.7417 20.8575 19.6317 22.9675 14.7017 22.9675Z"
								/>
								<path
									d="M11.999 12.9688C10.899 12.9688 9.89902 12.5387 9.18902 11.7487C8.47902 10.9587 8.14902 9.92875 8.25902 8.82875L8.92903 2.14875C8.96903 1.76875 9.28903 1.46875 9.67903 1.46875H14.349C14.739 1.46875 15.059 1.75875 15.099 2.14875L15.769 8.82875C15.879 9.92875 15.549 10.9587 14.839 11.7487C14.099 12.5387 13.099 12.9688 11.999 12.9688ZM10.349 2.96875L9.74902 8.97875C9.67902 9.64875 9.87903 10.2788 10.299 10.7388C11.149 11.6788 12.849 11.6788 13.699 10.7388C14.119 10.2688 14.319 9.63875 14.249 8.97875L13.649 2.96875H10.349Z"
								/>
								<path
									d="M18.308 12.9688C16.278 12.9688 14.468 11.3288 14.258 9.30875L13.558 2.29875C13.538 2.08875 13.608 1.87875 13.748 1.71875C13.888 1.55875 14.088 1.46875 14.308 1.46875H17.358C20.298 1.46875 21.668 2.69875 22.078 5.71875L22.358 8.49875C22.478 9.67875 22.118 10.7987 21.348 11.6488C20.578 12.4988 19.498 12.9688 18.308 12.9688ZM15.138 2.96875L15.758 9.15875C15.888 10.4087 17.048 11.4688 18.308 11.4688C19.068 11.4688 19.748 11.1788 20.238 10.6488C20.718 10.1188 20.938 9.40875 20.868 8.64875L20.588 5.89875C20.278 3.63875 19.548 2.96875 17.358 2.96875H15.138Z"
								/>
								<path
									d="M5.63904 12.9688C4.44904 12.9688 3.36904 12.4988 2.59904 11.6488C1.82904 10.7987 1.46904 9.67875 1.58904 8.49875L1.85904 5.74875C2.27904 2.69875 3.64904 1.46875 6.58905 1.46875H9.63904C9.84904 1.46875 10.049 1.55875 10.199 1.71875C10.349 1.87875 10.409 2.08875 10.389 2.29875L9.68904 9.30875C9.47904 11.3288 7.66904 12.9688 5.63904 12.9688ZM6.58905 2.96875C4.39904 2.96875 3.66904 3.62875 3.34904 5.91875L3.07904 8.64875C2.99904 9.40875 3.22904 10.1188 3.70904 10.6488C4.18904 11.1788 4.86904 11.4688 5.63904 11.4688C6.89904 11.4688 8.06904 10.4087 8.18904 9.15875L8.80905 2.96875H6.58905Z"
								/>
								<path
									d="M14.5 22.9688H9.5C9.09 22.9688 8.75 22.6287 8.75 22.2188V19.7188C8.75 17.6188 9.9 16.4688 12 16.4688C14.1 16.4688 15.25 17.6188 15.25 19.7188V22.2188C15.25 22.6287 14.91 22.9688 14.5 22.9688ZM10.25 21.4688H13.75V19.7188C13.75 18.4588 13.26 17.9688 12 17.9688C10.74 17.9688 10.25 18.4588 10.25 19.7188V21.4688Z"
								/>
							</svg>
						</div>
						<span class="text-center mx-1">{{
							'SIDEBAR.STORE' | translate
						}}</span>
					</a>
					<div *ngIf="tabs.openStore" class="mx-7">
						<a
							(click)="closeFun(); closeSubMenu('openStore')"
							routerLink="./store/orders"
							routerLinkActive="text-gradient"
							class="flex gap-2 items-center text-off-white cursor-pointer navbar-item mt-2"
						>
							<span class="text-center">{{
								'SIDEBAR.ORDERS' | translate
							}}</span>
						</a>
						<a
							(click)="closeFun(); closeSubMenu('openStore')"
							routerLink="./order-return"
							routerLinkActive="text-gradient"
							class="flex gap-2 items-center text-off-white cursor-pointer navbar-item mt-2"
						>
							<span class="text-center">{{
								'SIDEBAR.ORDER-RETURNS' | translate
							}}</span>
						</a>
						<a
							(click)="closeFun(); closeSubMenu('openStore')"
							routerLink="./store/products"
							routerLinkActive="text-gradient"
							class="flex gap-2 items-center text-off-white cursor-pointer navbar-item mt-2"
						>
							<span class="text-center">{{
								'SIDEBAR.PRODUCTS' | translate
							}}</span>
						</a>
						<a
							(click)="closeFun(); closeSubMenu('openStore')"
							routerLink="./store/categories"
							routerLinkActive="text-gradient"
							class="flex gap-2 items-center text-off-white cursor-pointer navbar-item mt-2"
						>
							<span class="text-center">{{
								'SIDEBAR.CATEGORIES' | translate
							}}</span>
						</a>

						<a
							(click)="closeFun(); closeSubMenu('openStore')"
							routerLink="./store/brands"
							routerLinkActive="text-gradient"
							class="flex gap-2 items-center text-off-white cursor-pointer navbar-item mt-2"
						>
							<span class="text-center">{{
								'SIDEBAR.BRANDS' | translate
							}}</span>
						</a>
						<a
							(click)="closeFun()"
							routerLink="./reviews"
							routerLinkActive="text-gradient"
							class="flex gap-2 items-center text-off-white cursor-pointer navbar-item mt-2"
						>
							<span class="text-center">{{
								'SIDEBAR.REVIEWS' | translate
							}}</span>
						</a>
					</div>
				</li>

				<!-- <li class="text-center px-[24px] mb-[20px]">
					<a
						(click)="closeFun(); closeSubMenu('')"
						routerLink="./logs"
						routerLinkActive="text-gradient"
						class="flex gap-2 items-center text-off-white cursor-pointer navbar-item"
					>
						<div class="w-[24px] mb-0.5">
							<svg viewBox="0 0 24 25">
								<path
									d="M16 22.9688H8C4.35 22.9688 2.25 20.8687 2.25 17.2188V7.21875C2.25 3.56875 4.35 1.46875 8 1.46875H16C19.65 1.46875 21.75 3.56875 21.75 7.21875V17.2188C21.75 20.8687 19.65 22.9688 16 22.9688ZM8 2.96875C5.14 2.96875 3.75 4.35875 3.75 7.21875V17.2188C3.75 20.0788 5.14 21.4688 8 21.4688H16C18.86 21.4688 20.25 20.0788 20.25 17.2188V7.21875C20.25 4.35875 18.86 2.96875 16 2.96875H8Z"
								/>
								<path
									d="M18.5 9.46875H16.5C14.98 9.46875 13.75 8.23875 13.75 6.71875V4.71875C13.75 4.30875 14.09 3.96875 14.5 3.96875C14.91 3.96875 15.25 4.30875 15.25 4.71875V6.71875C15.25 7.40875 15.81 7.96875 16.5 7.96875H18.5C18.91 7.96875 19.25 8.30875 19.25 8.71875C19.25 9.12875 18.91 9.46875 18.5 9.46875Z"
								/>
								<path
									d="M12 13.9688H8C7.59 13.9688 7.25 13.6287 7.25 13.2188C7.25 12.8088 7.59 12.4688 8 12.4688H12C12.41 12.4688 12.75 12.8088 12.75 13.2188C12.75 13.6287 12.41 13.9688 12 13.9688Z"
								/>
								<path
									d="M16 17.9688H8C7.59 17.9688 7.25 17.6287 7.25 17.2188C7.25 16.8088 7.59 16.4688 8 16.4688H16C16.41 16.4688 16.75 16.8088 16.75 17.2188C16.75 17.6287 16.41 17.9688 16 17.9688Z"
								/>
								<defs>
									<linearGradient
										id="paint0_linear_18015_40087"
										x1="2.25007"
										y1="10.686"
										x2="21.7501"
										y2="10.686"
										gradientUnits="userSpaceOnUse"
									>
										<stop stop-color="#F76EAA" />
										<stop offset="1" stop-color="#FA825C" />
									</linearGradient>
									<linearGradient
										id="paint1_linear_18015_40087"
										x1="13.75"
										y1="6.32666"
										x2="19.25"
										y2="6.32666"
										gradientUnits="userSpaceOnUse"
									>
										<stop stop-color="#F76EAA" />
										<stop offset="1" stop-color="#FA825C" />
									</linearGradient>
									<linearGradient
										id="paint2_linear_18015_40087"
										x1="7.25002"
										y1="13.1118"
										x2="12.75"
										y2="13.1118"
										gradientUnits="userSpaceOnUse"
									>
										<stop stop-color="#F76EAA" />
										<stop offset="1" stop-color="#FA825C" />
									</linearGradient>
									<linearGradient
										id="paint3_linear_18015_40087"
										x1="7.25004"
										y1="17.1118"
										x2="16.75"
										y2="17.1118"
										gradientUnits="userSpaceOnUse"
									>
										<stop stop-color="#F76EAA" />
										<stop offset="1" stop-color="#FA825C" />
									</linearGradient>
								</defs>
							</svg>
						</div>
						<span class="text-center text-off-white">{{
							'SIDEBAR.LOGS' | translate
						}}</span>
					</a>
				</li>  -->
				<li class="text-center pl-[24px] pr-[15px] mb-[20px]">
					<a
						(click)="closeFun(); closeSubMenu('openPointingSystem')"
						[ngClass]="tabs.openPointingSystem ? 'text-gradient' : ''"
						class="flex gap-2 items-center text-off-white cursor-pointer navbar-item"
					>
						<div class="w-5 mb-0.5">
							<svg width="24" height="25" viewBox="0 0 24 25">
								<path
									d="M12.1504 19.5707C11.7404 19.5707 11.4004 19.2307 11.4004 18.8207V16.7207C11.4004 16.3107 11.7404 15.9707 12.1504 15.9707C12.5604 15.9707 12.9004 16.3107 12.9004 16.7207V18.8207C12.9004 19.2307 12.5604 19.5707 12.1504 19.5707Z"
									fill="#FCFCFC"
								/>
								<path
									d="M17.9004 22.9707H6.40039V21.2207C6.40039 19.7007 7.63039 18.4707 9.15039 18.4707H15.1504C16.6704 18.4707 17.9004 19.7007 17.9004 21.2207V22.9707ZM7.90039 21.4707H16.4004V21.2207C16.4004 20.5307 15.8404 19.9707 15.1504 19.9707H9.15039C8.46039 19.9707 7.90039 20.5307 7.90039 21.2207V21.4707Z"
									fill="#FCFCFC"
								/>
								<path
									d="M18.1504 22.9707H6.15039C5.74039 22.9707 5.40039 22.6307 5.40039 22.2207C5.40039 21.8107 5.74039 21.4707 6.15039 21.4707H18.1504C18.5604 21.4707 18.9004 21.8107 18.9004 22.2207C18.9004 22.6307 18.5604 22.9707 18.1504 22.9707Z"
									fill="#FCFCFC"
								/>
								<path
									d="M18.4307 12.6612C18.2207 12.6612 18.0107 12.5713 17.8607 12.4013C17.6707 12.1813 17.6207 11.8713 17.7407 11.6113C18.0807 10.8313 18.2507 10.0012 18.2507 9.13125V6.13125C18.2507 5.78125 18.1907 5.44125 18.0707 5.08125C18.0607 5.05125 18.0507 5.01125 18.0407 4.97125C18.0107 4.82125 18.0007 4.67125 18.0007 4.53125C18.0007 4.12125 18.3407 3.78125 18.7507 3.78125H19.3507C21.1407 3.78125 22.6007 5.28125 22.6007 7.13125C22.6007 8.66125 21.9707 10.1712 20.8807 11.2613C20.8607 11.2812 20.8007 11.3312 20.7907 11.3412C20.2007 11.8313 19.5307 12.3813 18.6307 12.6313C18.5607 12.6513 18.5007 12.6612 18.4307 12.6612ZM19.6807 5.31125C19.7307 5.58125 19.7507 5.86125 19.7507 6.13125V9.13125C19.7507 9.54125 19.7207 9.93125 19.6607 10.3312C19.7207 10.2812 19.7707 10.2413 19.8307 10.1913C20.6307 9.39125 21.1007 8.27125 21.1007 7.13125C21.1007 6.23125 20.4907 5.47125 19.6807 5.31125Z"
									fill="#FCFCFC"
								/>
								<path
									d="M5.58039 12.6203C5.50039 12.6203 5.43039 12.6103 5.35039 12.5803C4.53039 12.3203 3.76039 11.8403 3.12039 11.2003C1.97039 9.93031 1.40039 8.54031 1.40039 7.07031C1.40039 5.25031 2.83039 3.82031 4.65039 3.82031H5.30039C5.55039 3.82031 5.79039 3.95031 5.93039 4.16031C6.07039 4.37031 6.09039 4.64031 5.99039 4.87031C5.83039 5.23031 5.75039 5.64031 5.75039 6.07031V9.07031C5.75039 9.93031 5.92039 10.7703 6.27039 11.5703C6.39039 11.8403 6.33039 12.1503 6.14039 12.3703C5.99039 12.5303 5.79039 12.6203 5.58039 12.6203ZM4.30039 5.35031C3.49039 5.51031 2.90039 6.21031 2.90039 7.07031C2.90039 8.16031 3.34039 9.21031 4.21039 10.1703C4.25039 10.2203 4.30039 10.2603 4.35039 10.3003C4.28039 9.89031 4.25039 9.48031 4.25039 9.07031V6.07031C4.25039 5.83031 4.27039 5.59031 4.30039 5.35031Z"
									fill="#FCFCFC"
								/>
								<path
									d="M12 16.9707C7.73 16.9707 4.25 13.4907 4.25 9.2207V6.2207C4.25 3.6007 6.38 1.4707 9 1.4707H15C17.62 1.4707 19.75 3.6007 19.75 6.2207V9.2207C19.75 13.4907 16.27 16.9707 12 16.9707ZM9 2.9707C7.21 2.9707 5.75 4.4307 5.75 6.2207V9.2207C5.75 12.6707 8.55 15.4707 12 15.4707C15.45 15.4707 18.25 12.6707 18.25 9.2207V6.2207C18.25 4.4307 16.79 2.9707 15 2.9707H9Z"
									fill="#FCFCFC"
								/>
							</svg>
						</div>
						<span class="text-center mx-1">{{
							'SIDEBAR.POINTING_SYSTEM' | translate
						}}</span>
					</a>
					<div *ngIf="tabs.openPointingSystem" class="mx-7">
						<a
							(click)="closeFun(); closeSubMenu('openPointingSystem')"
							routerLink="./pointing-system"
							[routerLinkActiveOptions]="{ exact: true }"
							routerLinkActive="text-gradient"
							class="flex gap-2 items-center text-off-white cursor-pointer navbar-item mt-2"
						>
							<span class="text-center">{{
								'SIDEBAR.CUSTOMIZE_POINTS' | translate
							}}</span>
						</a>
						<a
							(click)="closeFun(); closeSubMenu('openPointingSystem')"
							routerLink="./pointing-system/points-history"
							[routerLinkActiveOptions]="{ exact: true }"
							routerLinkActive="text-gradient"
							class="flex gap-2 items-center text-off-white cursor-pointer navbar-item mt-2"
						>
							<span class="text-center">{{
								'SIDEBAR.POINTS_HISTORY' | translate
							}}</span>
						</a>
						<a
							(click)="closeFun(); closeSubMenu('openPointingSystem')"
							routerLink="./pointing-system/points-statistics"
							[routerLinkActiveOptions]="{ exact: true }"
							routerLinkActive="text-gradient"
							class="flex gap-2 items-center text-off-white cursor-pointer navbar-item mt-2"
						>
							<span class="text-center">{{
								'SIDEBAR.POINTS_STATISTICS' | translate
							}}</span>
						</a>
					</div>
				</li>
				<li class="text-center px-[24px] mb-[20px]">
					<a
						(click)="closeFun(); closeSubMenu('openCustomization')"
						[ngClass]="tabs.openCustomization ? 'text-gradient' : ''"
						class="flex gap-2 items-center text-off-white cursor-pointer navbar-item"
					>
						<div class="w-5 mb-0.5">
							<svg width="24" height="25" viewBox="0 0 24 25">
								<path
									d="M18.4707 22.9688H14.4707C12.0507 22.9688 10.7207 21.6388 10.7207 19.2188V5.21875C10.7207 2.79875 12.0507 1.46875 14.4707 1.46875H18.4707C20.8907 1.46875 22.2207 2.79875 22.2207 5.21875V19.2188C22.2207 21.6388 20.8807 22.9688 18.4707 22.9688ZM14.4707 2.96875C12.8907 2.96875 12.2207 3.63875 12.2207 5.21875V19.2188C12.2207 20.7987 12.8907 21.4688 14.4707 21.4688H18.4707C20.0507 21.4688 20.7207 20.7987 20.7207 19.2188V5.21875C20.7207 3.63875 20.0507 2.96875 18.4707 2.96875H14.4707Z"
									fill="#FCFCFC"
								/>
								<path
									d="M16.4707 6.96875H11.4707C11.0607 6.96875 10.7207 6.62875 10.7207 6.21875C10.7207 5.80875 11.0607 5.46875 11.4707 5.46875H16.4707C16.8807 5.46875 17.2207 5.80875 17.2207 6.21875C17.2207 6.62875 16.8807 6.96875 16.4707 6.96875Z"
									fill="#FCFCFC"
								/>
								<path
									d="M15.4707 18.9688H11.4707C11.0607 18.9688 10.7207 18.6287 10.7207 18.2188C10.7207 17.8088 11.0607 17.4688 11.4707 17.4688H15.4707C15.8807 17.4688 16.2207 17.8088 16.2207 18.2188C16.2207 18.6287 15.8807 18.9688 15.4707 18.9688Z"
									fill="#FCFCFC"
								/>
								<path
									d="M16.4709 14.968C16.4609 14.968 16.4609 14.968 16.4709 14.968L11.4609 14.918C11.0509 14.918 10.7109 14.578 10.7209 14.158C10.7209 13.748 11.0609 13.418 11.4709 13.418C11.4709 13.418 11.4709 13.418 11.4809 13.418L16.4809 13.468C16.8909 13.468 17.2309 13.808 17.2209 14.228C17.2109 14.638 16.8809 14.968 16.4709 14.968Z"
									fill="#FCFCFC"
								/>
								<path
									d="M14.4707 10.9688H11.4707C11.0607 10.9688 10.7207 10.6287 10.7207 10.2188C10.7207 9.80875 11.0607 9.46875 11.4707 9.46875H14.4707C14.8807 9.46875 15.2207 9.80875 15.2207 10.2188C15.2207 10.6287 14.8807 10.9688 14.4707 10.9688Z"
									fill="#FCFCFC"
								/>
								<path
									d="M5.4893 22.9387C4.5793 22.9387 3.7193 22.3787 3.1293 21.3988L2.3093 20.0387C2.0093 19.5387 1.7793 18.7188 1.7793 18.1388V5.16875C1.7793 3.12875 3.4393 1.46875 5.4793 1.46875C7.5193 1.46875 9.1793 3.12875 9.1793 5.16875V18.1287C9.1793 18.7087 8.9493 19.5287 8.6493 20.0287L7.8293 21.3888C7.2593 22.3787 6.3993 22.9387 5.4893 22.9387ZM5.4893 2.96875C4.2793 2.96875 3.2893 3.95875 3.2893 5.16875V18.1287C3.2893 18.4387 3.4393 18.9888 3.5993 19.2588L4.4193 20.6187C4.7293 21.1388 5.1193 21.4287 5.4893 21.4287C5.8593 21.4287 6.2493 21.1287 6.5593 20.6187L7.3793 19.2588C7.5393 18.9888 7.6893 18.4387 7.6893 18.1287V5.16875C7.6893 3.95875 6.6993 2.96875 5.4893 2.96875Z"
									fill="#FCFCFC"
								/>
								<path
									d="M8.4393 7.96875H2.5293C2.1193 7.96875 1.7793 7.62875 1.7793 7.21875C1.7793 6.80875 2.1193 6.46875 2.5293 6.46875H8.4393C8.8493 6.46875 9.1893 6.80875 9.1893 7.21875C9.1893 7.62875 8.8493 7.96875 8.4393 7.96875Z"
									fill="#FCFCFC"
								/>
							</svg>
						</div>
						<span class="text-center mx-1">{{
							'SIDEBAR.CUSTOMIZATION' | translate
						}}</span>
					</a>
					<div *ngIf="tabs.openCustomization" class="mx-7">
						<a
							(click)="closeFun(); closeSubMenu('openCustomization')"
							routerLink="./customizing-mobile-app"
							[routerLinkActiveOptions]="{ exact: true }"
							routerLinkActive="text-gradient"
							class="flex gap-2 items-center text-off-white cursor-pointer navbar-item mt-2"
						>
							<span class="text-center">{{
								'SIDEBAR.STORE_PAGE' | translate
							}}</span>
						</a>
						<a
							(click)="closeFun(); closeSubMenu('openCustomization')"
							routerLink="./customizing-mobile-app/home-page-customization"
							[routerLinkActiveOptions]="{ exact: true }"
							routerLinkActive="text-gradient"
							class="flex gap-2 items-center text-off-white cursor-pointer navbar-item mt-2"
						>
							<span class="text-center">{{
								'SIDEBAR.HOME_PAGE' | translate
							}}</span>
						</a>
						<a
							(click)="closeFun(); closeSubMenu('openCustomization')"
							routerLink="./customizing-mobile-app/salon-page-customization"
							[routerLinkActiveOptions]="{ exact: true }"
							routerLinkActive="text-gradient"
							class="flex gap-2 items-center text-off-white cursor-pointer navbar-item mt-2"
						>
							<span class="text-center">{{
								'SIDEBAR.SALON_HOME_PAGE' | translate
							}}</span>
						</a>
					</div>
				</li>
			</ul>
			<ul>
				<li class="text-center px-[27px] mb-36px">
					<a
						(click)="closeFun(); closeSubMenu('')"
						routerLink="./settings/"
						routerLinkActive="text-gradient"
						class="flex text-off-white cursor-pointer navbar-item items-center"
					>
						<div class="w-[24px] mb-0.5">
							<svg width="24" height="24" viewBox="0 0 24 24">
								<path
									d="M12 15.75C9.93 15.75 8.25 14.07 8.25 12C8.25 9.93 9.93 8.25 12 8.25C14.07 8.25 15.75 9.93 15.75 12C15.75 14.07 14.07 15.75 12 15.75ZM12 9.75C10.76 9.75 9.75 10.76 9.75 12C9.75 13.24 10.76 14.25 12 14.25C13.24 14.25 14.25 13.24 14.25 12C14.25 10.76 13.24 9.75 12 9.75Z"
									fill="#FCFCFC"
								/>
								<path
									d="M15.21 22.1903C15 22.1903 14.79 22.1603 14.58 22.1103C13.96 21.9403 13.44 21.5503 13.11 21.0003L12.99 20.8003C12.4 19.7803 11.59 19.7803 11 20.8003L10.89 20.9903C10.56 21.5503 10.04 21.9503 9.42 22.1103C8.79 22.2803 8.14 22.1903 7.59 21.8603L5.87 20.8703C5.26 20.5203 4.82 19.9503 4.63 19.2603C4.45 18.5703 4.54 17.8603 4.89 17.2503C5.18 16.7403 5.26 16.2803 5.09 15.9903C4.92 15.7003 4.49 15.5303 3.9 15.5303C2.44 15.5303 1.25 14.3403 1.25 12.8803V11.1203C1.25 9.66029 2.44 8.47029 3.9 8.47029C4.49 8.47029 4.92 8.30029 5.09 8.01029C5.26 7.72029 5.19 7.26029 4.89 6.75029C4.54 6.14029 4.45 5.42029 4.63 4.74029C4.81 4.05029 5.25 3.48029 5.87 3.13029L7.6 2.14029C8.73 1.47029 10.22 1.86029 10.9 3.01029L11.02 3.21029C11.61 4.23029 12.42 4.23029 13.01 3.21029L13.12 3.02029C13.8 1.86029 15.29 1.47029 16.43 2.15029L18.15 3.14029C18.76 3.49029 19.2 4.06029 19.39 4.75029C19.57 5.44029 19.48 6.15029 19.13 6.76029C18.84 7.27029 18.76 7.73029 18.93 8.02029C19.1 8.31029 19.53 8.48029 20.12 8.48029C21.58 8.48029 22.77 9.67029 22.77 11.1303V12.8903C22.77 14.3503 21.58 15.5403 20.12 15.5403C19.53 15.5403 19.1 15.7103 18.93 16.0003C18.76 16.2903 18.83 16.7503 19.13 17.2603C19.48 17.8703 19.58 18.5903 19.39 19.2703C19.21 19.9603 18.77 20.5303 18.15 20.8803L16.42 21.8703C16.04 22.0803 15.63 22.1903 15.21 22.1903ZM12 18.4903C12.89 18.4903 13.72 19.0503 14.29 20.0403L14.4 20.2303C14.52 20.4403 14.72 20.5903 14.96 20.6503C15.2 20.7103 15.44 20.6803 15.64 20.5603L17.37 19.5603C17.63 19.4103 17.83 19.1603 17.91 18.8603C17.99 18.5603 17.95 18.2503 17.8 17.9903C17.23 17.0103 17.16 16.0003 17.6 15.2303C18.04 14.4603 18.95 14.0203 20.09 14.0203C20.73 14.0203 21.24 13.5103 21.24 12.8703V11.1103C21.24 10.4803 20.73 9.96029 20.09 9.96029C18.95 9.96029 18.04 9.52029 17.6 8.75029C17.16 7.98029 17.23 6.97029 17.8 5.99029C17.95 5.73029 17.99 5.42029 17.91 5.12029C17.83 4.82029 17.64 4.58029 17.38 4.42029L15.65 3.43029C15.22 3.17029 14.65 3.32029 14.39 3.76029L14.28 3.95029C13.71 4.94029 12.88 5.50029 11.99 5.50029C11.1 5.50029 10.27 4.94029 9.7 3.95029L9.59 3.75029C9.34 3.33029 8.78 3.18029 8.35 3.43029L6.62 4.43029C6.36 4.58029 6.16 4.83029 6.08 5.13029C6 5.43029 6.04 5.74029 6.19 6.00029C6.76 6.98029 6.83 7.99029 6.39 8.76029C5.95 9.53029 5.04 9.97029 3.9 9.97029C3.26 9.97029 2.75 10.4803 2.75 11.1203V12.8803C2.75 13.5103 3.26 14.0303 3.9 14.0303C5.04 14.0303 5.95 14.4703 6.39 15.2403C6.83 16.0103 6.76 17.0203 6.19 18.0003C6.04 18.2603 6 18.5703 6.08 18.8703C6.16 19.1703 6.35 19.4103 6.61 19.5703L8.34 20.5603C8.55 20.6903 8.8 20.7203 9.03 20.6603C9.27 20.6003 9.47 20.4403 9.6 20.2303L9.71 20.0403C10.28 19.0603 11.11 18.4903 12 18.4903Z"
									fill="#FCFCFC"
								/>
							</svg>
						</div>
						<span class="mx-[6px] text-center inline-block">{{
							'SIDEBAR.SETTING' | translate
						}}</span>
					</a>
				</li>
			</ul>
		</div>
	</div>
</aside>
